export const TOOL_GROUP = {
    PAINT_TOOL: "畫筆功能",
    PAGE_TOOL: "頁面顯示",
    INSERT_TOOL: "插入素材",
    LESSON_TOOL: "課堂功能",
    MATH_TOOL: "數學工具",
    SAVE_TOOL: "存檔讀檔",
    EXAM_TOOL: "評量測驗",
    CLASS_TOOL: "班級管理",
    SETTING_TOOL: "偏好設定"
}

export const ALIVE_TYPE = {
    KEEP: 0,
    ONCE: 1,
    NONE: 2
}

export const TOOLS = {
    TOOL_BOX: { TOOL: "tool_box", GROUP: "", TOOL_NAME: "工具箱", KEEP_ALIVE: ALIVE_TYPE.NONE },

    PEN: { TOOL: "pen", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "畫筆", KEEP_ALIVE: ALIVE_TYPE.KEEP },
    HIGHLIGHTER: { TOOL: "highlighter", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "螢光筆", KEEP_ALIVE: ALIVE_TYPE.KEEP },
    LASER_POINTER: { TOOL: "laser_pointer", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "雷射筆", KEEP_ALIVE: ALIVE_TYPE.KEEP },
    ERASER: { TOOL: "eraser", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "橡皮擦", KEEP_ALIVE: ALIVE_TYPE.KEEP },
    SELECTION: { TOOL: "selection", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "選取", KEEP_ALIVE: ALIVE_TYPE.KEEP },
    CLEAR: { TOOL: "clear", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "全部清除", KEEP_ALIVE: ALIVE_TYPE.NONE },
    UNDO: { TOOL: "undo", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "還原", KEEP_ALIVE: ALIVE_TYPE.NONE },
    REDO: { TOOL: "redo", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "取消還原", KEEP_ALIVE: ALIVE_TYPE.NONE },
    STAMP: { TOOL: "stamp", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "印章", KEEP_ALIVE: ALIVE_TYPE.ONCE },

    GO_LEFT_PAGE: { TOOL: "go_left_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "左翻", KEEP_ALIVE: ALIVE_TYPE.NONE },
    GO_PAGE: { TOOL: "go_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "頁碼跳頁", KEEP_ALIVE: ALIVE_TYPE.NONE },
    GO_RIGHT_PAGE: { TOOL: "go_right_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "右翻", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ZOOM_CORNER: { TOOL: "zoom_corner", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "四角放大", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ZOOM_OUT: { TOOL: "zoom_out", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "縮小", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ZOOM_IN: { TOOL: "zoom_in", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "放大", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ZOOM_NORMAL: { TOOL: "zoom_normal", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "原尺寸", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ZOOM_PART: { TOOL: "zoom_part", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "局部放大", KEEP_ALIVE: ALIVE_TYPE.ONCE },
    FULL_SCREEN: { TOOL: "full_screen", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "全螢幕", KEEP_ALIVE: ALIVE_TYPE.NONE },
    DIRECTORY: { TOOL: "directory", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "目錄", KEEP_ALIVE: ALIVE_TYPE.NONE },
    EXIT: { TOOL: "exit", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "關閉", KEEP_ALIVE: ALIVE_TYPE.NONE },
    PAGE_MODE: { TOOL: "page_mode", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "單雙頁", KEEP_ALIVE: ALIVE_TYPE.NONE },

    TEXT_TIP: { TOOL: "text_tip", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "便利貼", KEEP_ALIVE: ALIVE_TYPE.ONCE },
    TEXT_BOX: { TOOL: "text_box", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "文字方塊", KEEP_ALIVE: ALIVE_TYPE.ONCE },
    IMAGE: { TOOL: "image", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "插入圖片", KEEP_ALIVE: ALIVE_TYPE.ONCE },
    WEBLINK: { TOOL: "web_link", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "插入連結", KEEP_ALIVE: ALIVE_TYPE.ONCE },
    STICKER: { TOOL: "sticker", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "可撕貼紙", KEEP_ALIVE: ALIVE_TYPE.ONCE },

    LOTTERY: { TOOL: "lottery", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "選號器", KEEP_ALIVE: ALIVE_TYPE.NONE },
    WHITE_BOARD: { TOOL: "white_board", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "電子畫板", KEEP_ALIVE: ALIVE_TYPE.NONE },
    STAFF_KEYBOARD: { TOOL: "staff_keyboard", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "五線譜鍵盤", KEEP_ALIVE: ALIVE_TYPE.NONE },
    KEYBOARD: { TOOL: "keyboard", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "小鍵盤", KEEP_ALIVE: ALIVE_TYPE.NONE },
    GRAPHIC_BOARD: { TOOL: "graphic_board", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "圖文畫板", KEEP_ALIVE: ALIVE_TYPE.ONCE },

    COMPASSES: { TOOL: "compasses", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "圓規", KEEP_ALIVE: ALIVE_TYPE.NONE },
    PROTRACTOR: { TOOL: "protractor", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "量角器", KEEP_ALIVE: ALIVE_TYPE.NONE },
    RULER: { TOOL: "ruler", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "直尺", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ISOSCELES_TRIANGLE: { TOOL: "isosceles_triangle", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "等腰三角形", KEEP_ALIVE: ALIVE_TYPE.NONE },
    RIGHT_TRIANGLE: { TOOL: "right_triangle", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "直角三角形", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ANGLE_POLYGON: { TOOL: "angle_polygon", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "角度與多邊形", KEEP_ALIVE: ALIVE_TYPE.NONE },
    COMPUTER: { TOOL: "computer", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "計算機", KEEP_ALIVE: ALIVE_TYPE.NONE },
    SUMMARY_GRAPH: { TOOL: "summary_graph", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "統計圖", KEEP_ALIVE: ALIVE_TYPE.NONE },

    SAVE_RECORD: { TOOL: "save_record", GROUP: TOOL_GROUP.SAVE_TOOL, TOOL_NAME: "儲存檔案", KEEP_ALIVE: ALIVE_TYPE.NONE },
    LOAD_RECORD: { TOOL: "load_record", GROUP: TOOL_GROUP.SAVE_TOOL, TOOL_NAME: "開啟舊檔", KEEP_ALIVE: ALIVE_TYPE.NONE },
    MEMBER_LOGIN: { TOOL: "member_login", GROUP: TOOL_GROUP.SAVE_TOOL, TOOL_NAME: "雲端登入/登出", KEEP_ALIVE: ALIVE_TYPE.NONE },

    LESSON_EXAM: { TOOL: "lesson_exam", GROUP: TOOL_GROUP.EXAM_TOOL, TOOL_NAME: "隨堂測驗", KEEP_ALIVE: ALIVE_TYPE.NONE },
    ONLINE_EXAM: { TOOL: "online_exam", GROUP: TOOL_GROUP.EXAM_TOOL, TOOL_NAME: "即時測驗平臺", KEEP_ALIVE: ALIVE_TYPE.NONE },

    BIRTHDAY_PARTY: { TOOL: "birthday_party", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "生日同學會", KEEP_ALIVE: ALIVE_TYPE.NONE },
    HONOR_ROLL: { TOOL: "honor_roll", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "榮譽榜", KEEP_ALIVE: ALIVE_TYPE.NONE },
    COUNTDOWN: { TOOL: "countdown", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "倒數計時", KEEP_ALIVE: ALIVE_TYPE.NONE },
    STOPWATCH: { TOOL: "stopwatch", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "碼表", KEEP_ALIVE: ALIVE_TYPE.NONE },

    SETTING: { TOOL: "setting", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "全部設定", KEEP_ALIVE: ALIVE_TYPE.NONE },
    DISPLAY_TYPE: { TOOL: "display_type", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "頁面顯示比例", KEEP_ALIVE: ALIVE_TYPE.NONE },
    PEN_CLICK: { TOOL: "pen_click", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "畫筆點擊按鈕", KEEP_ALIVE: ALIVE_TYPE.NONE },
    CUSTOM_CURSOR: { TOOL: "custom_cursor", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "自訂滑鼠選單", KEEP_ALIVE: ALIVE_TYPE.NONE },
    PAGE_TAG: { TOOL: "page_tag", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "頁籤", KEEP_ALIVE: ALIVE_TYPE.NONE },
    UPDATE: { TOOL: "update", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "線上更新", KEEP_ALIVE: ALIVE_TYPE.NONE },
    DEFAULT_TOOL: { TOOL: "default_tool", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "預設工具列", KEEP_ALIVE: ALIVE_TYPE.NONE }
}

export const CURSOR_TOOLS = {
    PEN: { TOOL: "pen", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "畫筆" },
    HIGHLIGHTER: { TOOL: "highlighter", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "螢光筆" },
    LASER_POINTER: { TOOL: "laser_pointer", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "雷射筆" },
    ERASER: { TOOL: "eraser", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "橡皮擦" },
    SELECTION: { TOOL: "selection", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "選取" },
    CLEAR: { TOOL: "clear", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "全部清除" },
    UNDO: { TOOL: "undo", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "還原" },
    REDO: { TOOL: "redo", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "取消還原" },
    STAMP: { TOOL: "stamp", GROUP: TOOL_GROUP.PAINT_TOOL, TOOL_NAME: "印章", KEEP_ALIVE: ALIVE_TYPE.ONCE },

    GO_LEFT_PAGE: { TOOL: "go_left_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "左翻" },
    GO_PAGE: { TOOL: "go_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "頁碼跳頁" },
    GO_RIGHT_PAGE: { TOOL: "go_right_page", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "右翻" },
    ZOOM_OUT: { TOOL: "zoom_out", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "縮小" },
    ZOOM_IN: { TOOL: "zoom_in", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "放大" },
    ZOOM_NORMAL: { TOOL: "zoom_normal", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "原尺寸" },
    ZOOM_PART: { TOOL: "zoom_part", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "局部放大" },
    FULL_SCREEN: { TOOL: "full_screen", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "全螢幕" },
    DIRECTORY: { TOOL: "directory", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "目錄" },
    EXIT: { TOOL: "exit", GROUP: TOOL_GROUP.PAGE_TOOL, TOOL_NAME: "關閉" },

    TEXT_TIP: { TOOL: "text_tip", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "便利貼" },
    TEXT_BOX: { TOOL: "text_box", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "文字方塊" },
    IMAGE: { TOOL: "image", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "插入圖片" },
    WEBLINK: { TOOL: "web_link", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "插入連結" },
    STICKER: { TOOL: "sticker", GROUP: TOOL_GROUP.INSERT_TOOL, TOOL_NAME: "可撕貼紙" },

    LOTTERY: { TOOL: "lottery", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "選號器" },
    WHITE_BOARD: { TOOL: "white_board", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "電子畫板" },
    STAFF_KEYBOARD: { TOOL: "staff_keyboard", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "五線譜鍵盤" },
    KEYBOARD: { TOOL: "keyboard", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "小鍵盤" },
    GRAPHIC_BOARD: { TOOL: "graphic_board", GROUP: TOOL_GROUP.LESSON_TOOL, TOOL_NAME: "圖文畫板", KEEP_ALIVE: ALIVE_TYPE.ONCE },

    COMPASSES: { TOOL: "compasses", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "圓規" },
    PROTRACTOR: { TOOL: "protractor", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "量角器" },
    RULER: { TOOL: "ruler", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "直尺" },
    ISOSCELES_TRIANGLE: { TOOL: "isosceles_triangle", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "等腰三角形" },
    RIGHT_TRIANGLE: { TOOL: "right_triangle", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "直角三角形" },
    ANGLE_POLYGON: { TOOL: "angle_polygon", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "角度與多邊形" },
    COMPUTER: { TOOL: "computer", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "計算機" },
    SUMMARY_GRAPH: { TOOL: "summary_graph", GROUP: TOOL_GROUP.MATH_TOOL, TOOL_NAME: "統計圖" },

    SAVE_RECORD: { TOOL: "save_record", GROUP: TOOL_GROUP.SAVE_TOOL, TOOL_NAME: "儲存檔案" },
    LOAD_RECORD: { TOOL: "load_record", GROUP: TOOL_GROUP.SAVE_TOOL, TOOL_NAME: "開啟舊檔" },

    ONLINE_EXAM: { TOOL: "online_exam", GROUP: TOOL_GROUP.EXAM_TOOL, TOOL_NAME: "即時測驗平臺" },

    BIRTHDAY_PARTY: { TOOL: "birthday_party", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "生日同學會" },
    HONOR_ROLL: { TOOL: "honor_roll", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "榮譽榜" },
    COUNTDOWN: { TOOL: "countdown", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "倒數計時" },
    STOPWATCH: { TOOL: "stopwatch", GROUP: TOOL_GROUP.CLASS_TOOL, TOOL_NAME: "碼表" },

    SETTING: { TOOL: "setting", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "全部設定" },
    DISPLAY_TYPE: { TOOL: "display_type", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "頁面顯示比例" },
    PEN_CLICK: { TOOL: "pen_click", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "畫筆點擊按鈕" },
    CUSTOM_CURSOR: { TOOL: "custom_cursor", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "自訂滑鼠選單" },
    PAGE_TAG: { TOOL: "page_tag", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "頁籤" },
    DEFAULT_TOOL: { TOOL: "default_tool", GROUP: TOOL_GROUP.SETTING_TOOL, TOOL_NAME: "預設工具列" }
}

export const DEFAULT_TOOL = [
    TOOLS.TOOL_BOX,
    TOOLS.SAVE_RECORD,
    TOOLS.ERASER,
    TOOLS.UNDO,
    TOOLS.REDO,
    TOOLS.PEN,
    TOOLS.HIGHLIGHTER,
    TOOLS.CLEAR,
    TOOLS.SELECTION,
    TOOLS.GO_LEFT_PAGE,
    TOOLS.GO_PAGE,
    TOOLS.GO_RIGHT_PAGE,
    TOOLS.DIRECTORY,
    TOOLS.WHITE_BOARD,
    TOOLS.LOTTERY,
    TOOLS.ZOOM_CORNER,
    TOOLS.ZOOM_PART,
    TOOLS.ZOOM_NORMAL,
    TOOLS.FULL_SCREEN,
    TOOLS.DISPLAY_TYPE,
    TOOLS.PAGE_TAG

]

export const CORNER = {
    LEFT_TOP: "left_top",
    RIGHT_TOP: "right_top",
    LEFT_BOTTOM: "left_bottom",
    RIGHT_BOTTOM: "right_bottom"
}

export const AFILE_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    // TOOLS.PEN.TOOL,
    // TOOLS.HIGHLIGHTER.TOOL,
    // TOOLS.ERASER.TOOL,
    // TOOLS.SELECTION.TOOL,
    // TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    // TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    // TOOLS.ZOOM_NORMAL.TOOL,
    // TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    // TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,
    TOOLS.STAMP.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    // TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL,
]

export const AFILE_MOVIE_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    // TOOLS.PEN.TOOL,
    // TOOLS.HIGHLIGHTER.TOOL,
    // TOOLS.ERASER.TOOL,
    // TOOLS.SELECTION.TOOL,
    // TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    TOOLS.ZOOM_NORMAL.TOOL,
    TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,
    TOOLS.STAMP.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL,
]

export const WHITEBOARD_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    // TOOLS.PEN.TOOL,
    // TOOLS.HIGHLIGHTER.TOOL,
    // TOOLS.ERASER.TOOL,
    // TOOLS.SELECTION.TOOL,
    // TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    TOOLS.ZOOM_NORMAL.TOOL,
    TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    // TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL,
]

export const IFRAME_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    TOOLS.PEN.TOOL,
    TOOLS.HIGHLIGHTER.TOOL,
    TOOLS.LASER_POINTER.TOOL,
    TOOLS.ERASER.TOOL,
    TOOLS.SELECTION.TOOL,
    TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    TOOLS.ZOOM_NORMAL.TOOL,
    TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL
]

export const NO_STOP_POLYGON_TOOLS = [
    TOOLS.ZOOM_IN,
    TOOLS.ZOOM_OUT,
    TOOLS.ZOOM_NORMAL
]

export const STAMP_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    TOOLS.PEN.TOOL,
    TOOLS.HIGHLIGHTER.TOOL,
    TOOLS.LASER_POINTER.TOOL,
    TOOLS.ERASER.TOOL,
    // TOOLS.SELECTION.TOOL,
    TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    TOOLS.ZOOM_NORMAL.TOOL,
    TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL,
]
export const GRAPHIC_BOARD_DISABLE_TOOLS = [
    TOOLS.TOOL_BOX.TOOL,

    // TOOLS.PEN.TOOL,
    // TOOLS.HIGHLIGHTER.TOOL,
    // TOOLS.ERASER.TOOL,
    // TOOLS.SELECTION.TOOL,
    // TOOLS.CLEAR.TOOL,
    TOOLS.UNDO.TOOL,
    TOOLS.REDO.TOOL,

    TOOLS.GO_LEFT_PAGE.TOOL,
    TOOLS.GO_PAGE.TOOL,
    TOOLS.GO_RIGHT_PAGE.TOOL,
    TOOLS.ZOOM_CORNER.TOOL,
    TOOLS.ZOOM_OUT.TOOL,
    TOOLS.ZOOM_IN.TOOL,
    TOOLS.ZOOM_NORMAL.TOOL,
    TOOLS.ZOOM_PART.TOOL,
    TOOLS.FULL_SCREEN.TOOL,
    TOOLS.DIRECTORY.TOOL,
    TOOLS.EXIT.TOOL,
    TOOLS.PAGE_MODE.TOOL,

    TOOLS.TEXT_TIP.TOOL,
    TOOLS.TEXT_BOX.TOOL,
    TOOLS.IMAGE.TOOL,
    TOOLS.WEBLINK.TOOL,
    TOOLS.STICKER.TOOL,

    TOOLS.LOTTERY.TOOL,
    TOOLS.WHITE_BOARD.TOOL,
    TOOLS.STAFF_KEYBOARD.TOOL,
    TOOLS.KEYBOARD.TOOL,
    TOOLS.GRAPHIC_BOARD.TOOL,

    TOOLS.COMPASSES.TOOL,
    TOOLS.PROTRACTOR.TOOL,
    TOOLS.RULER.TOOL,
    TOOLS.ISOSCELES_TRIANGLE.TOOL,
    TOOLS.RIGHT_TRIANGLE.TOOL,
    TOOLS.ANGLE_POLYGON.TOOL,
    TOOLS.COMPUTER.TOOL,
    TOOLS.SUMMARY_GRAPH.TOOL,

    TOOLS.SAVE_RECORD.TOOL,
    TOOLS.LOAD_RECORD.TOOL,

    TOOLS.ONLINE_EXAM.TOOL,

    TOOLS.BIRTHDAY_PARTY.TOOL,
    TOOLS.HONOR_ROLL.TOOL,
    TOOLS.COUNTDOWN.TOOL,
    TOOLS.STOPWATCH.TOOL,

    TOOLS.SETTING.TOOL,
    TOOLS.DISPLAY_TYPE.TOOL,
    TOOLS.PEN_CLICK.TOOL,
    TOOLS.CUSTOM_CURSOR.TOOL,
    TOOLS.PAGE_TAG.TOOL,
    TOOLS.DEFAULT_TOOL.TOOL,
]

export const WEBVIEW_TYPE_DISABLE_TOOLS = [
    TOOLS.EXIT,
    // TOOLS.IMAGE,
    TOOLS.STAFF_KEYBOARD,
    TOOLS.KEYBOARD,
    TOOLS.SUMMARY_GRAPH,
    TOOLS.MEMBER_LOGIN,
    TOOLS.LESSON_EXAM,
    TOOLS.ONLINE_EXAM,
    TOOLS.BIRTHDAY_PARTY,
    TOOLS.HONOR_ROLL,
    TOOLS.UPDATE
]

export const WEBVIEW_TYPE_DISABLE_TOOL_GROUPS = [
    "EXAM_TOOL"
]

export const MAC_DISABLE_TOOLS = [
    TOOLS.STAFF_KEYBOARD,
    TOOLS.KEYBOARD,
    TOOLS.SUMMARY_GRAPH,
    TOOLS.BIRTHDAY_PARTY,
    TOOLS.HONOR_ROLL,
    TOOLS.UPDATE
]

export const APP_DISABLE_TOOLS = [
    TOOLS.CUSTOM_CURSOR,
    TOOLS.STAFF_KEYBOARD,
    TOOLS.KEYBOARD,
    TOOLS.SUMMARY_GRAPH,
    TOOLS.MEMBER_LOGIN,
    TOOLS.LESSON_EXAM,
    TOOLS.ONLINE_EXAM,
    TOOLS.BIRTHDAY_PARTY,
    TOOLS.HONOR_ROLL,
    TOOLS.UPDATE,
    TOOLS.FULL_SCREEN
]

export const APP_DISABLE_TOOL_GROUPS = [
    "EXAM_TOOL"
]